import React from 'react';
// import './helpers/clevertap';
import ReactDOM from 'react-dom/client';
import './index.css';
import{BrowserRouter} from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
// import GlobalStyle from "./style";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* <GlobalStyle /> */}
  </>
);

reportWebVitals();
